document.addEventListener("DOMContentLoaded", function () {

  var comparedItems = [];
  var pageName = document.title;
  var url = window.location.href;

  // =====================================================
  // 16. View Item (Page Load)
  // =====================================================
  if (window.productData) {
 
    clevertap?.event.push("View Item", window.productData);
  }

  // =====================================================
  // 17. Calculator Submitted
  // =====================================================  

  // =====================================================
  // 17. Calculator Submitted
  // =====================================================  
  document.addEventListener("submit", function(e) {
    var form = e.target;

    // =========================
    // 📥 GET FORM DATA
    // =========================
    var formData = {};
    var inputs = form.querySelectorAll("input, select, textarea");

    inputs.forEach(function(input) {
      var key = input.name || input.id;
      if (!key) return;
      var value = "";

      if (input.type === "checkbox") {
        value = input.checked;
      } else if (input.type === "radio") {
        if (!input.checked) return;
        value = input.value;
      } else {
        value = input.value;
      }

      formData[key] = value;

      // 💾 Save fallback
      if (value) {
        localStorage.setItem("form_" + key, value);
      }
    });

    // =========================
    // 👀 OBSERVE RESULT LOAD
    // =========================
    var resultContainer = document.querySelector("#result-container");

    if (!resultContainer) {
      console.warn("Result container not found");
      return;
    }

    var observer = new MutationObserver(function(mutations, obs) {
      var cards = resultContainer.querySelectorAll(".card");

      // ✅ Check if result loaded
      if (cards.length > 0) {
        // =========================
        // 📦 GET RESULT DATA
        // =========================

        // 👤 User summary
        var userDetails = resultContainer.querySelector("#user-details")?.innerText || "";

        // 💎 Gemstones
        var gemstones = [];

        cards.forEach(function(card) {
          gemstones.push({
            name: card.querySelector(".card-title")?.innerText || "",
            description: card.querySelector(".card-significance")?.innerText || "",
            image: card.querySelector("img")?.src || "",
            url: card.querySelector("a")?.href || ""
          });
        });

        // =========================
        // 🛍 PRODUCT DATA
        // =========================
        var product = window.currentBraceletProduct || window.productData || {};

        var eventData = {
          ...formData,

          // 📦 Result Data
          result_user_details: userDetails,
          recommended_: gemstones,

          // 🛍 Product Data
          product_id: product?.id || product?.product_id || localStorage.getItem("product_id") || "NA",
          product_name: product?.name || product?.item_name || localStorage.getItem("product_name") || "bracelet",
          product_image: product?.image || product?.item_image || "",
          product_name_url: product?.url || window.location.href,

          // 🌐 Page Info
          page_url: window.location.href,
          page_title: document.title
        }; 

        console.log("🔥 FINAL EVENT DATA:", eventData);

        // =========================
        // 🚀 SEND EVENT
        // =========================
        if (window.clevertap) {
          clevertap.event.push("All_Calculator", eventData);
        } else {
          console.warn("CleverTap not loaded");
        } 
        // 🛑 Stop observing (important)
        obs.disconnect();
      }
    });
    // 👀 Start observing
    observer.observe(resultContainer, {
      childList: true,
      subtree: true
    });
  });


  document.addEventListener("click", function(e) {

    // =====================================================
    // 1. Button Clicked
    // =====================================================
    var btn = e.target.closest("button, a");
    if (btn) {
   
      clevertap?.event.push("Button Clicked", {
        button_name: btn.innerText.trim() || "Unknown",
        page_name: pageName,
        page_url: url
      });
    }

    // =====================================================
    // 2. Menu Clicked
    // =====================================================
    var menu = e.target.closest(".header__primary-nav-item a");
    if (menu) {

      clevertap?.event.push("Menu Clicked", {
        menu_item: menu.innerText.trim(),
        page_name: pageName
      });
    }

    // =====================================================
    // 3. Share Product
    // =====================================================
    var share = e.target.closest("[data-share]");
    if (share && window.productData) {
 
      clevertap?.event.push("Share Product", {
        item_id: productData.item_id,
        item_name: productData.item_name,
        share_channel: share.dataset.channel || "unknown"
      });
    }

    // =====================================================
    // 4. Lead Form Viewed
    // =====================================================
    var formView = e.target.closest("[data-form-open]");
    if (formView) {
 
      clevertap?.event.push("Lead Form Viewed", {
        form_name: formView.dataset.formName || "Consultation",
        page_name: pageName
      });
    }

    // =====================================================
    // 5. Lead Form Submitted
    // =====================================================
    var form = e.target.closest("form.lead-form");
    if (form) {

      clevertap?.event.push("Lead Form Submitted", {
        form_name: "Consultation",
        user_name: form.querySelector("[name=name]")?.value,
        user_email: form.querySelector("[name=email]")?.value,
        user_phone: form.querySelector("[name=phone]")?.value,
        lead_source: pageName
      });
    }

    // =====================================================
    // 6. Call Request
    // =====================================================
    var call = e.target.closest("[data-call]");
    if (call) {

      clevertap?.event.push("Call Request", {
        user_name: call.dataset.name,
        user_phone: call.dataset.phone,
        preferred_time: call.dataset.time
      });
    }

    // =====================================================
    // 7. Chat Initiated
    // =====================================================
    var chat = e.target.closest("[data-chat]");
    if (chat) {

      clevertap?.event.push("Chat Initiated", {
        chat_type: chat.dataset.type || "Live Chat",
        page_name: pageName
      });
    }

    // =====================================================
    // 8. Add to Wishlist
    // =====================================================
    var wish = e.target.closest("[data-wishlist]");
    if (wish && window.productData) {

      clevertap?.event.push("Add to Wishlist", window.productData);
    }

    // =====================================================
    // 9. Remove from Wishlist
    // =====================================================
    var remWish = e.target.closest("[data-wishlist-remove]");
    if (remWish && window.productData) {
     
      clevertap?.event.push("Remove from Wishlist", {
        item_id: productData.item_id,
        item_name: productData.item_name,
        category: productData.category
      });
    }

    // =====================================================
    // 10. Compare Items
    // =====================================================
    var cmp = e.target.closest("[data-compare]");
    if (cmp) {
      var id = cmp.dataset.productId;
      var name = cmp.dataset.productName;
      if (!comparedItems.find(i => i.id === id)) {
        comparedItems.push({ id, name });
      }
    }

    var cmpNow = e.target.closest("[data-compare-trigger]");
    if (cmpNow && comparedItems.length) {
  
      clevertap?.event.push("Compare Items", {
        item_ids: comparedItems.map(i => i.id),
        item_names: comparedItems.map(i => i.name)
      });
    }

    // =====================================================
    // 11. Add to Cart
    // =====================================================
    var addCart = e.target.closest("[name='add']");
    if (addCart && window.productData) {

      clevertap?.event.push("Add to Cart", {
        ...productData,
        quantity: 1
      });
    }

    // =====================================================
    // 12. Remove from Cart
    // =====================================================
    var remCart = e.target.closest("[data-remove-cart]");
    if (remCart && window.productData) {

      clevertap?.event.push("Remove from Cart", {
        ...productData,
        quantity: 1
      });
    }

    // =====================================================
    // 13. Checkout Started
    // =====================================================
    var checkout = e.target.closest("[name='checkout']");
    if (checkout) {
     
      clevertap?.event.push("Checkout Started", {
        cart_value: window.cartTotal || 0,
        item_count: window.cartCount || 0
      });
    }

    // =====================================================
    // 14. Promo Clicked
    // =====================================================
    var promo = e.target.closest("[data-promo]");
    if (promo) {
   
      clevertap?.event.push("Promo Clicked", {
        promo_name: promo.dataset.name,
        promo_type: promo.dataset.type,
        page_name: pageName
      });
    }

    // =====================================================
    // 15. Referral Clicked
    // =====================================================
    var ref = e.target.closest("[data-referral]");
    if (ref) {
    
      clevertap?.event.push("Referral Clicked", {
        referral_id: ref.dataset.id,
        referrer_user_id: ref.dataset.user
      });
    }

  });

});